import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { sendInvite, getInvites, updateInvite } from '../../../reducers/invites';
import { RoleDefinitions } from '../../../utilities/roles';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import Modal from './../../modal';
import AddButton from '../addButton';
import { InviteForm } from '../../forms';
import { getAdmins } from '../../../reducers/users';
import { Snackbar } from '../../snackbar';
import { getFullName, beginsWith } from '../../../utilities/string';

class InviteUserButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: { open: false },
            invite: undefined
        };

        this.onInviteSubmitted = this.onInviteSubmitted.bind(this);

        // modal controls
        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
        this.sendNewInvite = this.sendNewInvite.bind(this);
        this.updateExistingInvite = this.updateExistingInvite.bind(this);
    }

    onInviteSubmitted(invite) {
        const { role, getInvites, onSuccess } = this.props;

        Snackbar.success(<FormattedMessage {...messages.inviteSuccess} values={{ name: getFullName(invite) }} />);
        getInvites(role, this.onClose);
        onSuccess();
    }

    onOpen() {
        this.setState({ ...this.state, modal: { open: true } });
    }

    onClose() {
        this.setState({ ...this.state, modal: { open: false }, invite: undefined });
    }

    componentDidMount() {
        const { role, availableAdminHrs, getAdmins } = this.props;
        if (role.role === RoleDefinitions.Admin.type && !availableAdminHrs) {
            getAdmins(role);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { modal } = this.state;
        const { update } = nextProps;
        if (!update) {
            return;
        }

        const { invite, onPassed } = update;

        if (!modal.open && invite && onPassed) {
            this.setState({ modal: { open: true }, invite: { ...invite } }, onPassed);
        }
    }

    sendNewInvite(values) {
        const { role, sendInvite } = this.props;
        const clientId = beginsWith(values.role, 'cl') ? values.clientId : undefined;
        sendInvite({ ...values, clientId }, role, () => this.onInviteSubmitted(values));
    }

    updateExistingInvite(values) {
        const { role, updateInvite } = this.props;
        updateInvite(values, role, () => this.onInviteSubmitted(values));
    }

    render() {
        const { modal, invite } = this.state;
        const { button, role, details, roles, availableAdminHrs, isNewClient } = this.props;

        let availableRoles = roles
            ? roles
            : role.type === 'client'
                ? [RoleDefinitions.Client, RoleDefinitions.ClientHiringManager]
                : [
                      RoleDefinitions.Admin,
                      RoleDefinitions.AdminFinance,
                      RoleDefinitions.AdminHumanResources,
                      RoleDefinitions.Client,
                      RoleDefinitions.ClientHiringManager,
                      RoleDefinitions.ClientAPI
                      // RoleDefinitions.ClientTimesheetApprover
                  ];

        let client = role.type === 'client' && details;

        let buttonComponent = button ? <div onClick={this.onOpen}>{button}</div> : <AddButton onClick={this.onOpen} />;

        let submitAction = invite ? this.updateExistingInvite : this.sendNewInvite;
        let initialValues = invite ? invite : { ref_id: role.id, ref_type: role.type, company_name: role.type === 'client' ? details.name : undefined };

        let title;
        if (invite === undefined) {
            title = isNewClient ? messages.inviteClient : messages.inviteUser;
        } else {
            title = messages.updateUserInvite;
        }
        return (
            <div>
                {buttonComponent}
                <Modal open={modal.open} onClose={this.onClose} managedClose size="col-sm-8 col-sm-offset-2 col-xs-12" title={<FormattedMessage {...title} />}>
                    <div className="row">
                        <InviteForm
                            onSubmit={submitAction}
                            cancel={this.onClose}
                            tenantType={role.type}
                            initialValues={initialValues}
                            availableRoles={availableRoles}
                            admins={availableAdminHrs}
                            isNewClient={isNewClient}
                            clientId={client && client.id}
                        />
                    </div>
                </Modal>
            </div>
        );
    }
}

InviteUserButton.defaultProps = {
    button: undefined,
    client: undefined,
    roles: undefined,
    onSuccess: () => {}
};
InviteUserButton.propTypes = {
    button: PropTypes.any,
    client: PropTypes.object,
    roles: PropTypes.array,
    isNewClient: PropTypes.bool,
    onSuccess: PropTypes.func
};

const mapStateToProps = state => {
    return {
        role: state.identity.role,
        details: state.identity.details,
        availableAdminHrs: state.users.admins
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAdmins: getAdmins,
            getInvites: getInvites,
            updateInvite: updateInvite,
            sendInvite: sendInvite
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(InviteUserButton);



// WEBPACK FOOTER //
// ./src/components/richButtons/inviteUserButton/index.jsx